"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionVideoSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("../enums");
exports.PromotionVideoSchema = zod_1.z.object({
    templateName: zod_1.z.nativeEnum(enums_1.PromotionVideoTemplateName),
    colorName: zod_1.z.nativeEnum(enums_1.PromotionVideoColorName),
    audioName: zod_1.z.nativeEnum(enums_1.PromotionVideoAudioName).optional(),
    phoneNumber: zod_1.z.string(),
    images: zod_1.z.string().array(),
    productName: zod_1.z.string(),
    promoText: zod_1.z.string(),
    label: zod_1.z.string(),
    renderedVideoUrl: zod_1.z.string().optional(),
    renderedThumbnailUrl: zod_1.z.string().optional(),
    renderedFileName: zod_1.z.string().optional(),
    price: zod_1.z.object({
        amount: zod_1.z.string(),
        currency: zod_1.z.string(),
        decimal: zod_1.z.string(),
        fraction: zod_1.z.string(),
        integer: zod_1.z.string(),
    }),
});
//# sourceMappingURL=video.js.map